import Workbench from './workbench/Workbench'
import ErrorBoundary from './workbench/ErrorBoundary'

export default function App() {
  return <ErrorBoundary><Workbench /></ErrorBoundary>
}
